import { ValidableField } from './ValidableField';
import { ChangeEvent } from 'react';
import { Input } from '@apia/theme';
import { makeValidableField } from './makeValidableField';

export const ValidableInput = makeValidableField(
  ({ type, context, label, path, onChange, ...props }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      context.setValue(path, event.target.value);
      onChange?.(event);
    };

    return (
      <ValidableField
        context={context}
        path={path as never}
        label={label}
        {...props}
        className={`input ${props.className}`}
      >
        <Input
          name={path}
          type={type}
          value={context.getValue(path)}
          onChange={handleChange}
        />
      </ValidableField>
    );
  },
);
